"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
exports.CSS = {
    container: 'c-Signup'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        display: 'flex',
        'flex-direction': 'column',
        'align-items': 'center',
        '& > .mdl-button': {
            width: '300px',
            'margin-top': '10px'
        }
    },
    _a);
//# sourceMappingURL=signup.style.js.map